import React from 'react';
import { BgSelector } from './BgSelector';
import { imagesBg } from '@teetsh/app/src/containers/printUtils/extractBgColorOrImage';

interface Props {
  value: string;
  onChange: (v: string) => void;
  limitedBgSet: boolean;
}

export function BgImageSelectorWithImages(props: Props) {
  const { value, onChange, limitedBgSet } = props;
  return (
    <BgSelector
      images={Object.entries(imagesBg)
        .filter(([, image]) => !image.hidden)
        .map(([key, image]) => ({
          ...image,
          locked: limitedBgSet && image.premium,
          key,
        }))}
      value={value.startsWith('image-') && !imagesBg[value] ? 'white' : value}
      onChange={onChange}
    />
  );
}
